import { render, staticRenderFns } from "./thelema-mountain-vineyards.vue?vue&type=template&id=a8c3a730&scoped=true"
import script from "./thelema-mountain-vineyards.vue?vue&type=script&lang=js"
export * from "./thelema-mountain-vineyards.vue?vue&type=script&lang=js"
import style0 from "./thelema-mountain-vineyards.vue?vue&type=style&index=0&id=a8c3a730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c3a730",
  null
  
)

export default component.exports